import React from 'react';
import { PieChart, Pie, Tooltip, Cell, Legend } from 'recharts';

// Данные о производстве животных продуктов
const dataSource = [
  {
    key: 1,
    animal: "Производство молока",
    count: 1777.6,
  },
  {
    key: 2,
    animal: "Производство шерсти в физическом весе",
    count: 12914,
  },
  {
    key: 3,
    animal: "Производство яиц (тыс/шт)",
    count: 685,
  },
  {
    key: 4,
    animal: "Производство мяса в убойном весе",
    count: 252.5,
  },
];

// Определяем цвета для каждой секции круговой диаграммы
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const AnimalProductionChart2 = () => {
  return (
    <div style={{  margin: '0 auto' }}>
      <h2>Производство животных продуктов</h2>
      <PieChart width={800} height={400}>
        <Pie
          data={dataSource}
          dataKey="count"
          nameKey="animal"
          cx="50%"
          cy="50%"
          outerRadius={150}
          fill="#8884d8"
          label
        >
          {dataSource.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </div>
  );
};

export default AnimalProductionChart2;
